import { motion } from 'framer-motion';

const driveIds = [
  '1SwnYXUmUiA8skLk4XJpcnzVRbK3nu5bJ',
  '1gLWY6nhRo8tYQ_q4SO-b7RU64FInTyHC',
  '1m-rQDLIPgnNc8UsDNYG5EdP8QVEMHbV4',
  '1FPC2bjQWWzXw4oJpmqf7AQjcNU1Nxuil',
  '1ZB2v4yVcXGjtvZPuGDpKOa4S7oWoa2IP',
  '16h_RYdYVE3J9_kNc_IHGW6eVUFXDBLa-',
  '1AojR0NFHHDCIH1y_fy4wbn3-zATK-c84',
  '1wtvC87kw5mPXtzWFfVzlI5gLLmaPVEas',
  '133RLlOqmk5Z2wOtO79kyypJPHmTAbA0F',
  '1jNe3_mdLarBFrq8n8IwxVfkqmyBB5Gp4',
  '1ttz1jI-c33pjo_eI4ND76bMV9nPiW4ai',
  '1HpDLIlU8Hj8-TiwcXgLUTNN-leUluhaE',
];

const images = driveIds.map((id) => `https://drive.google.com/thumbnail?id=${id}&sz=w600`);

function ImageRow({ items, reverse }) {
  const doubled = [...items, ...items];
  return (
    <div className="overflow-hidden">
      <div className={`flex gap-4 w-max ${reverse ? 'animate-marquee-reverse' : 'animate-marquee'}`}>
        {doubled.map((src, i) => (
          <div
            key={i}
            className="w-64 h-44 rounded-xl overflow-hidden flex-shrink-0 border-2 border-slate-700 hover:border-blue-500 transition-all duration-300 transform hover:scale-105"
          >
            <img
              src={src}
              alt={`Student testimonial ${(i % items.length) + 1}`}
              className="w-full h-full object-cover"
              loading="lazy"
            />
          </div>
        ))}
      </div>
    </div>
  );
}

export default function ImageTestimonials() {
  const row1 = images.slice(0, 6);
  const row2 = images.slice(6, 12);

  return (
    <section className="py-20 px-0 overflow-hidden bg-slate-800/50">
      <div className="max-w-6xl mx-auto px-4 mb-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center"
        >
          <span className="text-blue-400 text-sm font-semibold uppercase tracking-widest">Community Love</span>
          <h2 className="text-3xl md:text-5xl font-bold text-white mt-4 mb-4">
            Hundreds of <span className="bg-gradient-to-r from-yellow-400 to-orange-500 bg-clip-text text-transparent">Happy Students</span>
          </h2>
          <p className="text-xl text-gray-300">Swipe through to see what our students are saying</p>
        </motion.div>
      </div>
      <div className="space-y-4">
        <ImageRow items={row1} />
        <ImageRow items={row2} reverse />
      </div>
    </section>
  );
}